import React from "react";
import { BasicChequeredBoard, BasicChequeredBoardProps } from "../../components/BasicChequeredBoard/BasicChequeredBoard";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { List } from "../../components/List";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { GenericListProps } from "../../types/GenericListType";

export interface NewGasConnectionPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  lists?: GenericListProps[];
  secondParagraph?: ParagraphProps;
  chequeredBoard?: BasicChequeredBoardProps;
  faqs?: FaqAccordionGroupProps;
}

export const NewGasConnectionPage: React.FC<NewGasConnectionPageProps> = ({ seo, pageTitle, paragraphs, lists, chequeredBoard, faqs }) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
      {lists && lists[0] && <List {...lists[0]} />}
      {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
      {chequeredBoard && <BasicChequeredBoard {...chequeredBoard} />}
    </ServiceCataloguePageWrapper>
  );
};
